//noScroll
class MvAnimation {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const mvAnimation = () => {
      let tl = gsap.timeline({repeat: 0, repeatDelay: 1});

      if (window.matchMedia('(min-width: 768px)').matches) {
        tl.fromTo(".js-mv-fadeIn01", 0.5,
          {
            autoAlpha: 0,
            scale: 0.5,
            x: 100,

          }, {
            autoAlpha: 0.6,
            scale: 1.1,
            x: 100,
          }
        );
        tl.fromTo(".js-mv-fadeIn02", 0.7,
          {
            autoAlpha: 0,

          }, {
            autoAlpha: 1,
          },
          "<"
        );
        tl.fromTo(".js-mv-fadeIn01", 0.3,
          {
            x: 100,
            autoAlpha: 0.6,
            scale: 1.1,

          }, {
            x: 0,
            scale: 1,
            autoAlpha: 1,

          },


        );
        tl.fromTo(".js-mv-fadeIn03", 0.5,
          {
            autoAlpha: 0,

          }, {
            delay:0.5,
            autoAlpha: 1,
          }
        );
      }


      if (window.matchMedia('(max-width: 767px)').matches) {
        tl.fromTo(".js-mv-fadeIn01", 0.5,
        {
          autoAlpha: 0,
          scale: 0.5,
          x: 30,

        }, {
          autoAlpha: 0.6,
          scale: 1.1,
          x: 30,
        }
      );
      tl.fromTo(".js-mv-fadeIn02", 0.7,
        {
          autoAlpha: 0,

        }, {
          autoAlpha: 1,
        },
        "<"
      );
      tl.fromTo(".js-mv-fadeIn01", 0.3,
        {
          x: 30,
          autoAlpha: 0.6,
          scale: 1.1,

        }, {
          x: 0,
          scale: 1,
          autoAlpha: 1,

        },


      );
      tl.fromTo(".js-mv-fadeIn03", 0.5,
        {
          autoAlpha: 0,

        }, {
          delay:0.5,
          autoAlpha: 1,
        }
      );
      }




      }

    setTimeout(mvAnimation,600)


      function textAppear () {

        $(".js-mv-fadeIn02").css("opacity", 1)


        $('.strip').each(function(){
          var $t = $(this),
          rows = $.trim($t.html()).split('<br>');

          $t.html('');

          $.each(rows, function(i, val){
            $('<span class="row"></span>').appendTo($t);

            var letters = $.trim(val).split('');

            $.each(letters, function(j, v){
              v = (v == ' ') ? '&nbsp;' : v;
              $('<span class="textAnimation-item">' + $.trim(v) + '</span>').appendTo($('.row:last', $t));

            });

          });
        });

        for (let i = 0; i < $('.strip span').length; i++) {
          (function(ind) {
            setTimeout(function(){
                $('.strip span:not(".row")').eq(ind).addClass('animate');
            }, ind * 180);
          })(i);
        }

      }

  }
}
